"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesExporter = void 0;
var tslib_1 = require("tslib");
var numbering_list_1 = require("../../../core/model/numbering-lists/numbering-list");
var list_1 = require("@devexpress/utils/lib/utils/list");
var constants_1 = require("../../utils/constants");
var base_1 = require("./base");
var StylesExporter = (function (_super) {
    tslib_1.__extends(StylesExporter, _super);
    function StylesExporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StylesExporter.prototype, "filePath", {
        get: function () { return 'word/styles.xml'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylesExporter.prototype, "rootElement", {
        get: function () { return 'styles'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylesExporter.prototype, "rootNSPrefix", {
        get: function () { return this.data.constants.namespaces[constants_1.DocxNsType.WordProcessing].prefix; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylesExporter.prototype, "rootNSValue", {
        get: function () { return this.data.constants.namespaces[constants_1.DocxNsType.WordProcessing].namespace; },
        enumerable: false,
        configurable: true
    });
    StylesExporter.prototype.fillWriter = function () {
        var _this = this;
        this.exportDocumentDefaults();
        list_1.ListUtils.forEach(this.data.model.paragraphStyles, function (style, index) { return _this.data.parStyleExporter.export(style, index); });
        list_1.ListUtils.forEach(this.data.model.characterStyles, function (style, index) { return _this.data.charStyleExporter.export(style, index); });
        list_1.ListUtils.forEach(this.data.model.tableStyles, function (style, index) { return _this.data.tblStyleExporter.export(style, index); });
    };
    StylesExporter.prototype.exportDocumentDefaults = function () {
        this.writer.writeWpStartElement('docDefaults');
        this.exportDocumentCharacterDefaults();
        this.exportDocumentParagraphDefaults();
        this.writer.endElement();
    };
    StylesExporter.prototype.exportDocumentCharacterDefaults = function () {
        this.writer.writeWpStartElement('rPrDefault');
        this.writer.writeWpStartElement('rPr');
        this.data.charPropsExporter.exportRunPropertiesCore(this.data.model.defaultCharacterProperties);
        this.writer.endElement();
        this.writer.endElement();
    };
    StylesExporter.prototype.exportDocumentParagraphDefaults = function () {
        this.writer.writeWpStartElement('pPrDefault');
        this.writer.writeWpStartElement('pPr');
        this.data.parPropsExporter.exportParagraphPropertiesCore(this.data.model.defaultParagraphProperties, numbering_list_1.NumberingList.NumberingListNotSettedIndex, 0, null, true);
        this.writer.endElement();
        this.writer.endElement();
    };
    return StylesExporter;
}(base_1.ExporterBaseWithRootElement));
exports.StylesExporter = StylesExporter;
